import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { QUERY_CHEQUE_CONTRACT } from "../../service/ApolloClient/ApolloQueries";
import ChequeContractAddPage from "./ChequeContractAddPage";
import Loading from "../../components/UI/Loading/Loading";

class CarContractEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage = () => {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_CHEQUE_CONTRACT,
        variables: {
          id: parseInt(this.state.id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = res.data.chequeContract;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  render() {
    const { loading, data } = this.state;

    return (
      <Wrapper>
        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              <ChequeContractAddPage data={data} isEdit={true} />
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(CarContractEditPage);
